import type { PaymentAddress } from "../domains/transactions/customer-instruction";

export const getIsAddressValid = (
  canDefineAddress: boolean,
  isAddressUnstructured: boolean,
  isAddressOptional: boolean,
  isStructuredAddressValid: boolean,
  creditorAddress: PaymentAddress,
): boolean => {
  if (!creditorAddress.country) {
    return false;
  }

  if (!canDefineAddress) {
    return true;
  }

  if (isAddressUnstructured) {
    return isAddressOptional || (!!creditorAddress.addressLines && creditorAddress.addressLines.length > 0);
  }

  return isStructuredAddressValid;
};
